import { KawaiiSelect } from '@components/select';
import { useModels } from '@hooks/apollo/chat';
import { useEffect, type FC } from 'react';

interface ModelSelectProps {
  value?: string;
  onChange: (value: string) => void;
}

export const ModelSelect: FC<ModelSelectProps> = ({ value, onChange }) => {
  const { models } = useModels();

  useEffect(() => {
    console.log('value', value);
    if (models.length > 0 && !value) {
      onChange(models[0].modelId);
    }
  }, [models, onChange, value]);

  return (
    <KawaiiSelect
      value={value}
      onChange={onChange as (value: string | number) => void}
      className="py-2 pl-4 pr-3 dark:hover:bg-gray-700 dark:active:bg-gray-600 text-sm rounded-lg shadow-md shadow-gray-900/80"
      options={models.map((el) => ({
        value: el.modelId,
        label: el.modelName,
        renderOption: () => (
          <div key={el.modelId} className="flex flex-col">
            <div>{el.modelName}</div>
            <div className="flex gap-2 justify-between text-sm text-gray-500">
              <span className="max-w-32 overflow-hidden text-ellipsis">{el.modelId}</span>
              <span>{el.provider}</span>
            </div>
          </div>
        ),
      }))}
    />
  );
};
